import { Spin } from 'antd';
import Button from 'components/Button';
import ModalCommon from 'components/Input/ModalCommon';
import { useState } from 'react';
import CourseScheduleServices from 'services/CourseScheduleServices';
import { toast } from 'sonner';

const ModalConfirmChangeStatus = ({ onCancel, onSuccess, isOpen, courseId }) => {
  const [loading, setLoading] = useState(false);

  const handleChangeStatus = () => {
    setLoading(true);
    CourseScheduleServices.changeStatus(courseId ?? '')
      .then(() => {
        onSuccess();
      })
      .catch((err) =>
        toast.error(err?.message || err || '処理に失敗しました。もう一度お試しください。'),
      )
      .finally(() => setLoading(false));
  };

  return (
    <ModalCommon
      title="ステータスの変更"
      open={isOpen}
      onCancel={onCancel}
      footer={
        <div className="-mt-1 flex h-max justify-end gap-5 border-t border-[#e9e9e9] pt-[15px]">
          <Button btnType="back" width={120} height={40} onClick={onCancel}>
            キャンセル
          </Button>
          <Button onClick={handleChangeStatus} loading={loading}>
            変更する
          </Button>
        </div>
      }
    >
      <Spin spinning={loading}>
        <div
          style={{
            textAlign: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 400,
            color: '#000',
          }}
          className="h-[130px] xl:h-[80px] 2xl:h-[100px]"
        >
          ステータスを「開催確定」に変更します。
          <br />
          この操作は戻せません。
        </div>
      </Spin>
    </ModalCommon>
  );
};

export default ModalConfirmChangeStatus;
